define('pages/main/search',["jquery", "appquery", "app", "modules/searcher"], function($, $$, App, Searcher) {
    $$ = $$('search');

    function fetchResults(value) {
        this.search(value, function(results) {
            var message;
            if(!results.length) {
                message = 'Sorry, we could not find any products for this selection.';
            }
            App.page.append('products', {data: results, message: message}, $$('.products'));
        });
    }

    return {
        init : function(data) {
            var searchbox = $$('#searchbox');
            var searchPage = $$('#searchPage');
            var searchForm = $$('#searchForm');
            var searcher = new Searcher();
            fetchResults = fetchResults.bind(searcher);

            searchbox.focus();
            searchbox.on('input', App.utils.debounce(function() {
                searchbox.blur();
            }, 3000));
            searchbox.blur(function(e) {
                e.stopPropagation();
                if(!searchbox.val()) {
                    $$('.products').empty();
                }
                return false;
            });

            searchbox.on('input', App.utils.debounce(processInput, 500));
            searchForm.submit(function(e) {
                e.preventDefault();
            });

            function processInput() {
                var value = searchbox.val();
                if(value.length > 2) {
                    App.page.append('spinner', {
                        message : "Searching for " + value,
                        showFooter : true
                    }, $$('.products').empty());
                    App.utils.queue(function(){
                        fetchResults(value);
                    }, 250);
                }
                else {
                    App.page.append('products', {data: null, message: 'Please enter minimum 3 characters to search a product.'}, $$('.products'));
                }
            }

            if (data && data.searchValue) {
                searchbox.focus().val(data.searchValue);
                processInput();
            }
        },
        exit : function(data) {
            data.searchValue = $$('#searchbox').val();
            return data;
        },
        footer : true,
    };
});
